import { render, staticRenderFns } from "./BAbout.vue?vue&type=template&id=21430602&scoped=true&"
import script from "./BAbout.vue?vue&type=script&lang=js&"
export * from "./BAbout.vue?vue&type=script&lang=js&"
import style0 from "./BAbout.vue?vue&type=style&index=0&id=21430602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21430602",
  null
  
)

export default component.exports